import React from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Grid, Theme, Typography } from '@material-ui/core';

import { Link, PagesTitle, Button } from '../../../components';
import { ExclamationCircleIcon } from '../../../components/icon/solid';
import PageContainer from '../PageContainer';
import { useTitle } from "../../../hooks";
import { Links } from '../../../utility/links';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    height: '64px',
    width: '64px',
    color: palette.error.main,
  },
  title: {
    marginTop: '56px',
    marginBottom: '24px',
  },
  body: {
    color: palette.text.secondary,
    textAlign: 'center',
    fontSize: '16px',
    marginBottom: '42px',

    '& p': {
      marginBlockStart: 0,
    },
  },
  button: {
    minWidth: '189px',
    borderRadius: '5px',
    backgroundColor: palette.menuAction.selected,
    color: palette.common.white,
    fontFamily: 'Montserrat',
    fontSize: '16px',
    textTransform: 'none',
    marginBottom: '42px',
    '&:hover': {
      backgroundColor: palette.menuAction.selected,
    },
  },
  buttonLink: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
}), { name: 'InvitationPage' });


const InvitationSuccess = ({ message }: {message: string}) => {
  const classes = useStyles();

  useTitle('Invitation');

  const title = 'Invitation Error';
  const text = `The following error occurred while accepting the team invitation: ${message}`;

  const secondaryText = 'Please contact customer support if you are not sure why this error occurred.';


  return (
    <PageContainer>
      <Grid container className={classes.root}>
        <ExclamationCircleIcon className={classes.icon} />
        <PagesTitle className={classes.title}>{title}</PagesTitle>
        <Typography variant="body1" component="div" className={classes.body}>
          <p>{text}</p>
          <p>{secondaryText}</p>
        </Typography>
        <Link to={Links.support} className={classes.buttonLink}>
          <Button className={classes.button}>
            Customer Support
          </Button>
        </Link>
      </Grid>
    </PageContainer>
  )
};

export default InvitationSuccess;
